import { render, staticRenderFns } from "./AssessmentEndButton.vue?vue&type=template&id=04db717e&"
import script from "./AssessmentEndButton.vue?vue&type=script&lang=js&"
export * from "./AssessmentEndButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports